module.exports = __webpack_public_path__ + "img/trade-pwd.png";